import { useQuery } from 'react-query';
import { getDriverRoster } from '../../services/MessagingService';

/**
 * Fetches the full driver roster (active + inactive).
 *
 * If the roster endpoint (/deliveryops/drivers/roster) is not yet available,
 * the service layer falls back to the active drivers endpoint with a console warning.
 *
 * TODO: Once /deliveryops/drivers/roster is created by the Eatzy API team,
 * the fallback in MessagingService.getDriverRoster() can be removed.
 */
export const useDriverRoster = () => {
  const { data, isFetching, error, refetch } = useQuery(
    'driver-roster',
    getDriverRoster,
    {
      staleTime: 60000,
    }
  );

  return {
    roster: data ?? [],
    isLoading: isFetching,
    error,
    refetch,
  };
};
